import AscFlightDataContainer from './containers/AscFlightDataContainer.vue'

const fleetDataRouter = {
  icon: 'mdi-equalizer',
  path: '/flight-data',
  name: 'Flight Data',
  display: true,
  component: AscFlightDataContainer,
  meta: {
    primaryNavigation: true,
    requiresEccn: true,
    tooltip: 'View flight data',
    breadcrumbs: [
      {
        text: 'Home',
        to: '/',
      },
      {
        text: 'Flight Data',
      },
    ],
  },
  children: [],
}

export default fleetDataRouter
